import * as React from 'react';
import { classes } from './CopyUrlButton.st.css';
import { Check, Link } from '@wix/wix-ui-icons-common/on-stage';
import { Toast, ToastSkin, ToastPlacement } from '../Toast';
const renderSuccess = ({ mobile, successText }) => {
    if (mobile) {
        return (React.createElement(Toast, { skin: ToastSkin.success, placement: ToastPlacement.bottomFullWidth, shouldAnimate: true, isShown: true },
            React.createElement("div", { className: classes.success },
                React.createElement(Check, null),
                React.createElement("span", { className: classes.successText }, successText))));
    }
    return (React.createElement("div", { className: classes.success },
        React.createElement(Check, { className: classes.checkIcon }),
        React.createElement("span", { className: classes.successText }, successText)));
};
export const getButtonIcon = ({ mobile, successText, success, icon = React.createElement(Link, null), }) => {
    if (success) {
        if (mobile) {
            return (React.createElement(React.Fragment, null,
                icon,
                renderSuccess({ mobile, successText })));
        }
        else {
            return renderSuccess({ mobile, successText });
        }
    }
    return icon;
};
//# sourceMappingURL=CopyUrlButton.utils.js.map